import {
  ContentWrapper,
  Description,
  HeaderWrapper,
  Image,
  ImageWrapper,
  LikeWrapper,
  Name,
  ProductLabels,
} from './content.styles';

import LikeCount from '../../../../../../../common/like_count';
import ProductLabel from '../../../../../../../common/product_label';
import ProductLikeButton from '../../../../../../../common/product_like_button';

import useI18nText from '../../../../../../../../hooks/useI18nText';

import type {
  Product,
  ProductProduct,
  ProductWithDynamicPropertiesForUser,
} from '@rewardopl/types';

function getIsProductProduct(product: Product): product is ProductProduct {
  return product.type === 'product';
}

type ContentProps = {
  product: ProductWithDynamicPropertiesForUser;
};

export default function Content({ product }: ContentProps) {
  const { description, description_i18n: descriptionI18n, name, name_i18n: nameI18n } = product;

  const nameString = useI18nText(nameI18n, name);
  const descriptionString = useI18nText(descriptionI18n, description?.trim() ?? '');

  const isProductProduct = getIsProductProduct(product);

  return (
    <>
      <HeaderWrapper>
        {product.picture ? (
          <ImageWrapper>
            <Image
              alt={nameString}
              src={`/api/uploads/${product.picture}?w=${112 * devicePixelRatio}`}
              width={112}
            />
          </ImageWrapper>
        ) : null}
        <ContentWrapper>
          <Name>{nameString}</Name>
          {descriptionString ? <Description>{descriptionString}</Description> : null}
          <ProductLabels>
            {isProductProduct ? (
              <>
                {product.is_vegan ? <ProductLabel variant="vegan" /> : null}
                {product.is_vegetarian ? <ProductLabel variant="vegetarian" /> : null}
                {product.contains_alcohol ? <ProductLabel variant="contains_alcohol" /> : null}
                {product.is_alcohol_free ? <ProductLabel variant="alcohol_free" /> : null}
                {product.is_gluten_free ? <ProductLabel variant="gluten_free" /> : null}
                {product.is_lactose_free ? <ProductLabel variant="lactose_free" /> : null}
                {product.is_sugar_free ? <ProductLabel variant="sugar_free" /> : null}
              </>
            ) : null}
            {product.tags?.map((tag) => (
              <ProductLabel key={tag}>{tag}</ProductLabel>
            ))}
          </ProductLabels>
        </ContentWrapper>
      </HeaderWrapper>
      <LikeWrapper>
        <ProductLikeButton productId={product._id} />
        <LikeCount count={product.like_count} />
      </LikeWrapper>
    </>
  );
}
